import { Injectable } from '@angular/core';
import {Headers, Http} from '@angular/http';
import {UvmApi} from './uvm.api';
import {map} from 'rxjs/operators';
import {CookieService} from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class SubmitApplicationService {
  private uvmApi: UvmApi;

  constructor(private http: Http,
              private cookieService: CookieService) {
    this.uvmApi = UvmApi.Singleton;
  }

  submitApplication(data) {
    console.log(data);
    let headers: Headers;
    headers = this.uvmApi.headers;
    headers.append('Authorization', 'Bearer ' + this.cookieService.get('UVMAppLoggedInToken'));
    headers.append('AuthenticationType', 'Propsect');
    headers.append('Body', 'application/json');
    return this.http
      .post((this.uvmApi.url + '/admissions/1.0/submitUVMOpp'), data, {headers})
      .pipe(
        map(res => res.json()));
  }
}
